const item = {
    namespaced: true,
    state: {
      meetUserinfo:{},
      FileMsg:{},
      latlog:[],
      mapMsg:{},
      menu:''
    },
    getters: {
    },
    mutations: {
      getmeetUserinfo (state, info) {
        state.meetUserinfo = info
      },
      getFileMsg (state, info) {
        state.FileMsg = info
      },
      getLatlog (state, info) {
        state.latlog = info
      },
      getMapmsg (state, info) {
        state.mapMsg = info
      },
      ceeateEenu (state, info) {
        state.menu = info
      },
  
    },
    actions: {

      }
    }
  
  
  export default item
  